var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Transfer',{attrs:{"list-style":_vm.listStyle,"data":_vm.transferData,"target-keys":_vm.targetKeys,"render-format":_vm.render1,"titles":[_vm.transferTitle]},on:{"on-change":_vm.handleChange1}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe41efe6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/SystemSettings/components/TabsTransferComponent.vue
// module id = null
// module chunks = 